<template>
  <div class="col-lg-12">
    <a-modal modal-id="auto-seo-modal">
    <div slot="title">Auto Seo Order</div>
    <div slot="form">
      <div class="row">
        <div>
          <label>Language</label>
          <v-select :options="languages" v-model="autoSeoRequest.language" index="language_code" label="language_name" placeholder="Language"></v-select>
        </div>
        <div class="m-t-sm">
          <label>AI Instructions</label><br>
          <small><b>{keywords}</b> will be replaced by keywords</small>
          <textarea class="form-control" v-model="autoSeoRequest.prompt" cols="25" rows="8"></textarea>
        </div>
        <div class="m-t-sm">
          <label>Max Keywords Per Paragraph</label><br>
          <small>Number of keywords that can be added to a single paragraph</small>
          <input type="number" v-model="autoSeoRequest.maxKeywords" class="form-control">
        </div>
        <div class="m-t-sm">
          <label>Min Keyword Impressions</label><br>
          <small>Number of impressions the keyword needs to be included</small>
          <input type="number" v-model="autoSeoRequest.minKwImpressions" class="form-control">
        </div>
        <div class="m-t-sm">
          <label>Page Limit</label><br>
          <small>Optional. Leave empty for all</small>
          <input type="number" v-model="autoSeoRequest.pageLimit" class="form-control">
        </div>
        <div class="m-t-sm">
          <label>Keyword Limit</label><br>
          <small>Optional. Leave empty for all</small>
          <input type="number" v-model="autoSeoRequest.keywordLimit" class="form-control">
        </div>
      </div>
    </div>
    <div slot="footer">
      <button class="btn btn-primary btn-sm" @click="sendRequest()">Send Request</button>
    </div>
  </a-modal>
    <div class="row">
        <div class="col-lg-2">
            <table class="table table-hover">
                <thead>
                    <tr>
                      <th colspan="2">
                        <button
                          class="btn btn-sm btn-primary btn-xs"
                          @click="openSeoModal()"
                        ><i class="fa fa-plus"></i> Request new</button>
                      </th>
                    </tr>
                  <tr>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                    <tr v-for="order in checks" :key="order.id" style="cursor: pointer;" @click="loadOrderResult(order.id)">
                        <td>
                            <span>
                                <i v-if="order.status === 'completed'" class="fa fa-check fa-lg green" v-tooltip="'Completed'"></i>
                                <i v-else-if="order.status === 'processing'" class="fa fa-clock fa-lg yellow" v-tooltip="'Running'"></i>
                                <i v-else class="fa-solid fa-x fa-lg red" v-tooltip="'Failed'"></i>
                            </span>
                        </td>
                        <td>
                            <span style="display: block;">
                                {{ order.startTime | aTime }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-lg-10">
            <div v-if="activeOrderResult || true">
                <table class="table table-hover">
                    <tbody v-for="url in activeOrderResult" :key="url">
                    <tr v-for="(par, index) in url.paragraphs" :key="'paragraph-' + index">
                      <td>
                        <div class="col-lg-12">
                          {{ par.usable }} | Keywords: {{ par.keywords }}
                        </div>
                        <div v-html="par.text"></div>
                      </td>
                    </tr>
                        <tr>
                            <td>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <strong class="m-r-sm">Url:</strong> <a :href="url.url" target="_blank">{{ url.url }}</a><br>
                                        <strong class="m-r-sm">Keywords:</strong> {{ url.keywords.join(' | ') }}<br>
                                        Impressions: <strong>{{ url.impressions }}</strong> | Clicks: <strong>{{ url.clicks }}</strong> | Ctr:  <strong>{{ url.ctr }}</strong>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="col-lg-6">
                                    <div class="row p-sm">
                                        <strong>Original Content:</strong>
                                        <span class="pull-right text-justify">
                                            <a @click="copyToClipboard(url.oldContent)">
                                                <i class="fa fa-copy" v-tooltip="'Copy content'"></i>
                                            </a>
                                        </span>
                                    </div>
                                    <div class="row m-t-xs p-sm" v-html="url.oldContent">
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="row p-sm">
                                        <strong>New Content:</strong>
                                        <span class="pull-right">
                                            <a @click="copyToClipboard(url.newContent)">
                                                <i class="fa fa-copy" v-tooltip="'Copy new content'"></i>
                                            </a>
                                        </span>
                                    </div>
                                    <div class="row m-t-xs p-sm" id="new-content" v-html="url.newContent">
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import languages from '../../../../../../static/languages.json'
import countries from '../../../../../../static/countries.json'
import { Browser, FormValidation } from '../../../../../mixins/helperMixin'

export default {
  data () {
    return {
      checks: [],
      activeOrderResult: null,
      autoSeoRequest: {
        language: null,
        prompt: 'I am about to give you some content(html), and you are going to intelligently insert keywords (it does not need to be case sensitive, do it however it best makes sense). The keywords are {keywords}. Change as little as possible; and just return back the new content and nothing else.'
      },
      languages,
      countries,
      activeOrder: {},
      highlightedChangesElement: ''
    }
  },
  mixins: [Browser, FormValidation],
  computed: {
    ...mapGetters({
      site: 'getPbn'
    })
  },
  mounted () {
    this.loadRuns()
  },
  methods: {
    openSeoModal () {
      $('#auto-seo-modal').modal('show')
    },
    async sendRequest () {
      let check = this.mandatoryData(['prompt'], this.autoSeoRequest)
      if (check !== true) {
        this.$toastr.warning('Missing data for: ' + check.join(', '), 'I Need Some More Data')
        return
      }
      try {
        await axios.post(`/toolbox/order`, {
          type: 'auto-seo',
          payload: {
            domain: this.site.punyDomain,
            language: this.autoSeoRequest.language,
            prompt: this.autoSeoRequest.prompt,
            pageLimit: this.autoSeoRequest.pageLimit,
            keywordLimit: this.autoSeoRequest.keywordLimit,
            maxKeywords: this.autoSeoRequest.maxKeywords,
            minKwImpressions: this.autoSeoRequest.minKwImpressions
          }
        })
        $('#auto-seo-modal').modal('hide')
        await this.loadRuns()
      } catch (error) {
        this.$toastr.error(error, 'Failed to send request')
      }
    },
    async loadRuns () {
      let r = await axios.get(`/pbn/site/${this.site.punyDomain}/tools/auto-seo/list`)
      this.checks = r.data
    },
    async loadOrderResult (id) {
      const res = await axios.get(`/pbn/site/${this.site.punyDomain}/tools/auto-seo/result/${id}`)
      this.activeOrderResult = res.data
    },
    // TODO: add function to highlight difference between the old and the new content
    highlightChanges () {
      let newContentElem = document.getElementById('new-content-' + this.activeOrder.keyword)
      console.log('we got the elem: ', newContentElem)
      let text = ''
      let lettersList = this.activeOrder.newContent.split('')

      for (let i = 0; i < lettersList.length; i++) {
        if (lettersList[i] !== this.activeOrder.originalContent.charAt(i)) {
          text += `<span class="highlighted-difference">${lettersList[i]}</span>`
        } else {
          text += lettersList[i]
        }
      }

      if (text.includes('class="highlighted-difference"')) {
        newContentElem.innerHTML = text
      }
      return newContentElem
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Tabs/AutoSeo.vue